<div class="row">
  <!-- Side Menu -->
  <div class="col-lg-1 col-12">
    <app-uiform-side-menu [uiformId]="uiformId" targetId="aireport">
    </app-uiform-side-menu>
  </div>

  <!-- Main Content -->
  <div class="col-lg-11 col-12 ps-lg-0 my-margin-left">
    <div class="row mt-2">
      <div class="col-12 ms-1">
        <div class="card shadow-sm border-0">
          <div class="card-header bg-secondary text-white py-3 border-0">
            <div class="row g-2 align-items-center">
              <div class="col-md-8 mt-0">
                <h5 class="mb-0 text-white">
                  <i class="fas fa-robot me-2"></i
                  >{{ "AI_Assistant.Assistant" | translate }}
                </h5>
              </div>
              <div class="col-md-4 text-md-end">
                <span class="badge bg-light text-dark">NCS^ Platform</span>
              </div>
            </div>
          </div>
          <div class="card-body p-0">
            <!-- Chat History -->
            <div
              #chatHistory
              class="chat-history p-3"
              style="min-height: 400px; overflow-y: auto"
            >
              <!-- Welcome Message -->
              <div class="message ai-message mb-3">
                <div class="d-flex">
                  <div class="flex-shrink-0">
                    <div
                      class="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center"
                      style="width: 36px; height: 36px"
                    >
                      <i class="fas fa-robot"></i>
                    </div>
                  </div>
                  <div class="flex-grow-1 ms-3">
                    <div class="rounded p-3 shadow-sm bg-light">
                      <p class="mb-0">
                        Hello! I'm your AI assistant. How can I help you today?
                      </p>
                    </div>
                    <small class="text-muted">{{
                      "AI_Assistant.Just_now" | translate
                    }}</small>
                  </div>
                </div>
              </div>

              <!-- Chat Messages -->
              <div
                *ngFor="let message of chatMessages"
                [class]="
                  message.type === 'user'
                    ? 'message user-message mb-3'
                    : 'message ai-message mb-3'
                "
              >
                <div
                  class="d-flex"
                  [class.flex-row-reverse]="message.type === 'user'"
                >
                  <div class="flex-shrink-0">
                    <div
                      [class]="
                        message.type === 'user'
                          ? 'bg-secondary text-white rounded-circle d-flex align-items-center justify-content-center'
                          : 'bg-primary text-white rounded-circle d-flex align-items-center justify-content-center'
                      "
                      style="width: 36px; height: 36px"
                    >
                      <i
                        [class]="
                          message.type === 'user'
                            ? 'fas fa-user'
                            : 'fas fa-robot'
                        "
                      ></i>
                    </div>
                  </div>
                  <div
                    class="flex-grow-1"
                    [class.ms-3]="message.type === 'ai'"
                    [class.me-3]="message.type === 'user'"
                  >
                    <div
                      class="rounded p-3 shadow-sm"
                      [class.bg-primary]="message.type === 'user'"
                      [class.text-white]="message.type === 'user'"
                      [class.bg-light]="message.type === 'ai'"
                    >
                      <div [innerHTML]="message.content"></div>
                    </div>
                    <small class="text-muted d-block mt-1">{{
                      message.timestamp
                    }}</small>
                  </div>
                </div>
              </div>

              <!-- Loading Indicator -->
              <div *ngIf="isLoading" class="message ai-message mb-3">
                <div class="d-flex">
                  <div class="flex-shrink-0">
                    <div
                      class="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center"
                      style="width: 36px; height: 36px"
                    >
                      <i class="fas fa-robot"></i>
                    </div>
                  </div>
                  <div class="flex-grow-1 ms-3">
                    <div class="rounded p-3 shadow-sm bg-light">
                      <div class="d-flex align-items-center">
                        <div
                          class="spinner-border spinner-border-sm text-primary me-2"
                          role="status"
                        >
                          <span class="visually-hidden">{{
                            "AI_Assistant.Loading" | translate
                          }}</span>
                        </div>
                        <p class="mb-0">
                          {{ "AI_Assistant.Thinking" | translate }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Input Area -->
            <div
              class="input-section p-3 border-top compact-inputs dropdown-pd-none"
            >
              <div class="row g-2">
                <div class="col-md-10">
                  <div class="d-flex align-items-center gap-2">
                    <!-- Material Input Field -->
                    <mat-form-field
                      appearance="outline"
                      class="ai-input-width"
                      subscriptSizing="dynamic"
                    >
                      <input
                        matInput
                        type="text"
                        [(ngModel)]="userInput"
                        (keyup.enter)="sendMessage()"
                        [disabled]="isLoading"
                        placeholder="{{ 'AI_Assistant.Place' | translate }}"
                      />
                    </mat-form-field>
                    <!-- Clear button as mat-stroked-button outside the field -->
                    <button
                      mat-stroked-button
                      color="primary"
                      class="d-flex align-items-center justify-content-center"
                      (click)="clearChat()"
                      [disabled]="isLoading"
                      matTooltip="Clear chat"
                      aria-label="Clear chat"
                    >
                      <mat-icon>backspace</mat-icon>
                      <span>{{ "AI_Assistant.Clear" | translate }}</span>
                    </button>
                  </div>
                </div>

                <div class="col-md-2">
                  <button
                    mat-raised-button
                    color="primary"
                    class="w-100 d-flex align-items-center justify-content-center"
                    (click)="sendMessage()"
                    [disabled]="!userInput.trim() || isLoading"
                  >
                    <mat-icon class="me-2">send</mat-icon>
                    <span>{{ "AI_Assistant.Send" | translate }}</span>
                  </button>
                </div>
              </div>
              <div class="mt-2">
                <small class="text-muted">
                  <i class="fas fa-lightbulb me-1"></i>
                  {{ "AI_Assistant.Info" | translate }}
                </small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>